<div class="row mt-2">
  <div class="col-12">
    <div class="border rounded-3 shadow-sm bg-body p-3">
      <div class="row g-3 align-items-center">
        <div class="col-12 col-xl-3">
          <div class="d-flex align-items-center gap-3">
            <div
              class="d-inline-flex align-items-center justify-content-center flex-shrink-0 rounded-2 bg-primary-subtle text-primary p-2 fs-4 lh-1"
              aria-hidden="true"
            >
              <i class="fa-brands fa-microsoft"></i>
            </div>
            <div class="d-flex flex-wrap align-items-center gap-2 lh-sm">
              <span class="fw-semibold text-body">Microsoft Entra ID</span>
              @if (!linkedTenant) {
                <span
                  class="badge rounded-pill border border-secondary-subtle bg-secondary-subtle text-secondary-emphasis fw-semibold"
                >
                  <i class="fa-solid fa-circle-xmark me-1"></i>
                  {{ app.getText("user.entraStatusNotConnected") }}
                </span>
              }
              @if (linkedTenant) {
                <span
                  class="badge rounded-pill border border-success-subtle bg-success-subtle text-success-emphasis fw-semibold"
                >
                  <i class="fa-solid fa-circle-check me-1"></i>
                  {{ app.getText("user.entraStatusConnected") }}
                </span>
              }
            </div>
          </div>
        </div>

        <div class="col-12 col-xl-6">
          <div class="row g-3">
            @if (!linkedTenant) {
              <div class="col-12 small text-body-secondary">
                {{ app.getText("user.entraStatusNotConnectedHint") }}
              </div>
            }
            @if (linkedTenant) {
              <div class="col-12 col-md-4">
                <small class="d-block text-body-secondary mb-1">
                  {{ app.getText("user.entraName") }}
                </small>
                <div
                  class="small fw-medium text-truncate"
                  [title]="linkedTenant.displayName"
                >
                  {{ linkedTenant.displayName || "—" }}
                </div>
              </div>
              <div class="col-12 col-md-5">
                <small class="d-block text-body-secondary mb-1">
                  {{ app.getText("user.entraTenantId") }}
                </small>
                <code
                  class="d-block small text-body-secondary text-truncate bg-transparent"
                  [title]="linkedTenant.tenantId"
                >
                  {{ linkedTenant.tenantId }}
                </code>
              </div>
              @if (linkedTenant.adminConsentTime) {
                <div class="col-12 col-md-3">
                  <small class="d-block text-body-secondary mb-1">
                    {{ app.getText("user.entraConnectedOn") }}
                  </small>
                  <div class="small fw-medium text-break">
                    {{
                      linkedTenant.adminConsentTime
                        | date: "dd MMM yyyy, HH:mm"
                    }}
                  </div>
                </div>
              }
            }
          </div>
        </div>

        <div class="col-12 col-xl-3">
          <div class="d-flex flex-wrap gap-2 justify-content-xl-end">
            <button
              type="button"
              class="btn btn-link btn-sm text-secondary text-decoration-none"
              (click)="toggleEntraBenefits()"
            >
              <i class="fa-regular fa-circle-question me-1"></i>
              {{ app.getText("user.entraHelpLink") }}
            </button>
            <button
              type="button"
              class="btn btn-light border btn-sm"
              (click)="startAdminConsent()"
            >
              <i class="fa-brands fa-microsoft me-1"></i>
              @if (!linkedTenant) {
                {{ app.getText("user.entraConnectButton") }}
              }
              @if (linkedTenant) {
                {{ app.getText("user.entraReConnectButton") }}
              }
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
